import React, { Component } from "react";
import { translate } from "react-polyglot";
import { Col } from "reactstrap";
import { Subscribe } from "unstated";
import { BuildupTemplatesComponent } from "../../generated/graphql";
import FilterState from "../../state/FilterState";
import { Template } from "../../types/Template";
import BasicSelect from "../fields/BasicSelect";
import findParameters from "../helpers/findParameters";

class BuildupTemplateSelect extends Component<TranslateProps> {
  public render() {
    const { t } = this.props;
    return (
      <Col className="pt-2 col-12">
        <Subscribe to={[FilterState]}>
          {(filterState: any) => {
            const handleTemplateSelect = (template: Template) =>
              filterState.handleTemplateSelect(template);

            const templateIdFilter = filterState.state.filters.find(
              (f: any) => f.parameter === "templateId"
            );

            return (
              <BuildupTemplatesComponent variables={{ page: 0 }}>
                {({ loading, error, data }) => {
                  if (loading) {
                    return <div>{t("labels.loading")}</div>;
                  }

                  if (error) {
                    console.error(error);
                    return <div>{t("errors.failedToFetch")}</div>;
                  }

                  if (!data) {
                    return t("errors.buildupTemplates");
                  }

                  const templates = data.buildupTemplates.map(template => {
                    return {
                      label: template.name,
                      value: template.id
                    };
                  });

                  return (
                    <BasicSelect
                      options={templates}
                      fieldName="templateId"
                      paramOperator="contains"
                      defaultValue={templates[0]}
                      value={
                        templateIdFilter ? templateIdFilter.values[0] : null
                      }
                      handleSelect={(e: any) =>
                        findParameters(
                          handleTemplateSelect,
                          data.buildupTemplates,
                          e
                        )
                      }
                    />
                  );
                }}
              </BuildupTemplatesComponent>
            );
          }}
        </Subscribe>
      </Col>
    );
  }
}

export default translate()(BuildupTemplateSelect);
